@if (contextualHelp$ | async; as contextualHelp) {
  <a tabindex="0" role="button" data-cy="app-more-info-link__more-info-link" (keyup.enter)="$event.target.click()" class="info-link pl-4 more-info" (click)="openDialog(contextualHelp)">More info</a>
}
